import { Box, Button, Stack, Text, styled } from '@ltvco/refresh-lib/theme';

import { DEFAULT_VISIT_CLAIM_CTA_LABEL } from '../shared/constants';
import { ReportStatStrip } from '../shared/ReportStatStrip';
import { DefendantHeading } from '../shared/reportTypography';
import { toSafeHttpUrl } from '../shared/safeHttpUrl';

import type { DocketDetailRelatedCaseItem } from '../types';

const MiniCardShell = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  border: 'none',
  boxShadow: '0 0 0 1px #e0e0e0',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
}));

const CaseTitleText = styled(Text)(({ theme }) => ({
  fontFamily: `'Nunito Sans', ${theme.typography.fontFamily}`,
  fontSize: 'clamp(1.125rem, 2vw, 1.25rem)',
  fontWeight: 700,
  lineHeight: 1.25,
}));

export function RelatedCaseMiniCard({
  item,
}: {
  item: DocketDetailRelatedCaseItem;
}) {
  const defendant = item.primary_defendant_or_target?.trim();
  const title = item.case_title?.trim();
  const claimUrl = toSafeHttpUrl(item.visit_claim_url);
  const hasClaimUrl = Boolean(claimUrl);
  const claimCtaLabel = DEFAULT_VISIT_CLAIM_CTA_LABEL;

  return (
    <MiniCardShell>
      <Stack spacing={1.25}>
        {defendant ? <DefendantHeading>{defendant}</DefendantHeading> : null}
        {title ? <CaseTitleText>{title}</CaseTitleText> : null}
        <ReportStatStrip
          deadlineAbsolute={item.deadline_absolute_text?.trim()}
          payout={item.payout_summary?.trim()}
          proof={item.proof_requirement_summary?.trim()}
        />
        {hasClaimUrl ? (
          <Button
            variant="outlined"
            size="small"
            sx={(theme) => ({
              alignSelf: 'flex-start',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: theme.spacing(4),
            })}
            onClick={() =>
              claimUrl && window.open(claimUrl, '_blank', 'noopener,noreferrer')
            }
          >
            {claimCtaLabel}
          </Button>
        ) : null}
      </Stack>
    </MiniCardShell>
  );
}
